import { useTranslation } from 'react-i18next';
import React from 'react';
import { FormType } from '../../backend/openapi/api-types';
import { usePathBuilder } from '../../../core/routing/hooks/use-path-builder';
import { SearchParam } from '../../../core/routing/param';
import { useSearchParam } from '../../../core/routing/hooks/use-search-param';
import { AuthenticatedForm } from './authenticated-form';

export const DeleteUser: React.FC = () => {
  const { t } = useTranslation();
  const { profileSettingsPath } = usePathBuilder();
  const { emailToDelete } = useSearchParam([SearchParam.emailToDelete]);
  const queryParam = emailToDelete ? { emailToDelete } : undefined;

  const linkBackTo = { to: profileSettingsPath(), label: t('form.backToProfileSettings') };

  return (
    <AuthenticatedForm
      documentTitle={t('form.deleteUser.documentTitle')}
      formType={FormType.deleteUser}
      linkBackTo={linkBackTo}
      queryParam={queryParam}
    />
  );
};
